package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesLocationDto(
    val latitude: Double,
    val longitude: Double,
    val city: String,
    val country: String,
)
